// @flow
import React, {PureComponent} from "react";
import {arrowDown, arrowUp} from "../icons";

type Props = {
    name: string;
    label: string,
    sortedBy: string,
    sortedDirection?: string,
    isLoading: boolean,
    onChange?: Function,
    noSort?: boolean
}

type State = {
    sortDirection: string
}

class TableHeading extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            sortDirection: this.props.sortedDirection ? this.props.sortedDirection : "desc",
        };

        this.changeDirection = this.changeDirection.bind(this);
    }

    static defaultProps = {
        isLoading: false
    }

    changeDirection(e: any) {
        e.preventDefault();
        if (!this.props.isLoading) {
            const id = e.currentTarget.id;
            const cellName = id ? id : this.props.name;
            this.setState(prevState => {
                const direction = (this.isActiveSort() && prevState.sortDirection === "desc") ? "asc" : "desc";
                this.handleOnChange(cellName, direction);
                return {sortDirection: direction};
            });
        }
    }

    handleOnChange(field: string, direction: 'asc'|'desc') {
        if (this.props.onChange !== undefined) {
            this.props.onChange(field, direction);
        }
    }

    isActiveSort() {
        return (this.props.sortedBy === this.props.name);
    }

    render() {
        return this.props.noSort ? (
            <th>
                <span>{this.props.label}</span>
            </th>
        ) : (
            <th style={{width: `${this.props.label === "Title" ? "330px" : ""}`}}>
                <button
                    type="button"
                    className={`btn btn-link sort-${this.state.sortDirection} ${this.isActiveSort() ? "active-sort" : ""}`}
                    onClick={this.changeDirection}
                >

                    {this.isActiveSort() && (
                        this.state.sortDirection === "asc" ? (
                            <span>{arrowUp}</span>
                        ) : (
                            <span>{arrowDown}</span>
                        )
                    )}

                    <span>{this.props.label}</span>
                </button>
            </th>
        );
    }
}

export default TableHeading;